import React, { FC } from 'react'
import { IonHeader } from '@ionic/react'
import { observer } from 'mobx-react'
import { Icon } from '@cps'
import './index.scss'

interface IProps {
  className?: string;
  title?: string;
  onBack?: () => void;
  children?: any;
}

const Header: FC<IProps> = ({ className = '', title = '', onBack, children }: IProps) => {
  return (
    <IonHeader>
      <div className={`header-wrapper ${className}`}>
        {onBack && <div onClick={onBack}><Icon name='BACK-12x' /></div>}
        {!!title && <div className='title'>{title}</div>}
        {children}
      </div>
    </IonHeader>
  )
}

export default observer(Header)
